import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';
import { Location_Inspection } from '../../../models/location_inspection';
import { Page } from '../../../models/paging/page';
import { CompanyService } from '../../../services/company.service';
import { LocationService } from '../../../services/location.service';
import { JobService } from '../../../services/rs/job.service';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import * as moment from 'moment';
import { saveAs as importedSaveAs } from 'file-saver';
import { ReportableService } from '../../../services/reportable.service';

@Component({
  selector: 'app-job-management',
  templateUrl: './job-management.component.html',
  styleUrls: ['./job-management.component.css']
})
export class JobManagementComponent implements OnInit {
  filter: any = {
    company_Id: 0,
    location_Id: 0,
    job_No: '',
    created_date_Range: 12,
    created_start_Date: moment().add(-12, 'months').toDate(),
    created_end_Date: moment().toDate(),
    //scheduled_date_Range: 12,
    //scheduled_start_Date: moment().add(-12, 'months').toDate(),
    //scheduled_end_Date: moment().toDate()
  };
  init: boolean;
  locationList: Location[];

  companies: Company[];
  locations: Location[];

  page = new Page();
  rows = Array<Location_Inspection>();

  constructor(public companyService: CompanyService, public locationService: LocationService, public reportableService: ReportableService,
    public jobService: JobService, public router: Router, private confirmationService: ConfirmationService) {

    this.page.pageNumber = 0;
    this.page.size = 10;

    /*this.companyService.getAll().then((data) => {
      this.companies = data;
      this.locationService.getAll().then((data) => {
        this.locationList = data;
      });
    });*/
  }

  onCompanyChange(value) {
    this.filter.location_Id = 0;
    if (value == 0) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  ngOnInit() {
    //window.scroll(0, 0);
    this.setPage({ offset: 0 });
    this.init = true;
  }

  complete(job) {
    //let jobDetails = 'Company: ' + job.company.name + '<br/>';
    //jobDetails += 'Location: ' + job.location.name + '<br/>';
    console.log(job);
    let jobDetails = 'Job No: ' + job.job_No + ' ID: ' + job.id;
    this.confirmationService.confirm({
      message: 'Are you sure that you want complete this job?</br><br/>' + jobDetails,
      accept: () => {
        this.jobService.complete(job.id).then(() => {
          this.loadTable(this.page);
        });
      }
    });
  }

  edit(job) {
    this.router.navigate(['administration/jobs/manage'], { queryParams: { id: job.id } });
  }

  delete(job) {
    let jobDetails = 'Company: ' + job.company.name + '<br/>';
    jobDetails += 'Location: ' + job.location.name + '<br/>';
    jobDetails += 'Job No: ' + job.job_No;
    this.confirmationService.confirm({
      message: 'Are you sure that you want delete this job?</br><br/>' + jobDetails,
      accept: () => {
        this.jobService.delete(job.id).then(() => {
          this.loadTable(this.page);
        });
      }
    });
  }


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.jobService.getResults(this.page, this.filter.company_Id, this.filter.location_Id, this.filter.job_No, false,
      this.filter.created_start_Date, this.filter.created_end_Date).then((pagedData) => {
      this.page = pagedData.page;
        this.rows = pagedData.data;
        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
    });
  }
  dateChange(ev,type) {
    if (ev == -1) {
      return;
    }

    let date = moment();
    if (ev == 0) {
      date = date.subtract(1, 'weeks');
    } else {
      date = date.subtract(ev, 'months');
    }

    let jsDate = date.toDate();
    //var startDate: NgbDateStruct = { year: jsDate.getFullYear(), month: jsDate.getMonth() + 1, day: jsDate.getDate() };
    if(type ==1)
      this.filter.created_start_Date = jsDate;
    else if (type == 2)
      this.filter.scheduled_start_Date = jsDate;
  }

  generateExcel() {
    this.jobService.getExcel(this.page, this.filter.company_Id, this.filter.location_Id, this.filter.job_No, false,
      this.filter.created_start_Date, this.filter.created_end_Date, this.filter.scheduled_start_Date, this.filter.scheduled_end_Date).then((data) => {
      importedSaveAs(data, 'Report.xlsx');
    });
  }
  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  downloadReport(id: number) {
    this.reportableService.getJobForm(id).then((data) => {
      importedSaveAs(data, 'Breakdown Inspection Report.pdf');
    });
  }

}
